import React from "react";

function ProductOne({
  picture,
  pictureorj,
  title = "Aypin Otomat CNC talaşlı imalat",
}) {
  return (
    <div className="card border-0">
      <div className="card-body">

        <a
          href={pictureorj}
          data-fslightbox="gallery"
          aria-label={`${title} görselini büyüt`}
        >
          <img
            src={picture}
            className="figure-img1 img-fluid rounded-0 shadow"
            alt={title}
            title={title}
            loading="lazy"
            decoding="async"
          />
        </a>

        {title && (
          <h6 className="card-title text-center mt-2">
            {title}
          </h6>
        )}

      </div>
    </div>
  );
}

export default ProductOne;